<template>
  <div class="content-container">
    <van-nav-bar :title="$t('common.memberCenter')" left-arrow @click-left="onClickBack" :right-text="$t('actionTitles.submitModify')" @click-right="handleSubmit"/>
    <van-cell-group class="cell-group-style">
      <van-cell :title="$t('form.common.field.account.label')" :value="form.phone"/>
      <van-cell :title="$t('form.common.field.name.label')" is-link :value="form.name" @click="isShowName = true" />
      <van-cell :title="$t('common.avatar')" is-link >
        <DragUploader ref="uploader" uptype="avatar" :callback="getUploader">
          <template slot="body">
            <img
              :src="form.avatar?form.avatar:avatar"
              alt="avatar"
              slot="default"
              class="avatar"
            />
          </template>
        </DragUploader>
      </van-cell>
      <van-cell :title="$t('form.common.field.gender.label')" >
        <van-radio-group style="justify-content: flex-end;" v-model="form.gender" direction="horizontal">
          <van-radio :name="1">{{$t('enum.gender.male')}}</van-radio>
          <van-radio :name="0">{{$t('enum.gender.female')}}</van-radio>
        </van-radio-group>
      </van-cell>
      <!-- <van-cell title="所在地區" :value="form.region">
        <span slot="default">
          <HRegionSelect @regionData="selectedData" :defaultValue="defaultValue"></HRegionSelect>
        </span>
      </van-cell> -->
      <region :reginValue="defaultValue" @updateRegin="updateRegin"></region>
      <van-cell :title="$t('publish.address.label')" is-link :value="form.address?form.address:''" @click="isShowDetail = true"/>
      <van-cell :title="$t('form.common.field.mobile.label')" is-link :value="form.tel" @click="isShowTel = true"/>
    </van-cell-group>

    <van-cell :title="$t('moduleTitles.safeSetting')" is-link style="margin-top:5px" @click="$router.push({name:'personal/secure'})" />

    <div class="submit">
      <a-button @click="logout"  shape="round" block style="height: 38px">{{$t('common.logout')}}</a-button>
    </div>
    <!--修改帳號-->
    <!--修改暱稱-->
    <van-dialog v-model="isShowName" :title="$t('form.common.field.name.title')" show-cancel-button @confirm="confirmName">
      <div style="padding: 5px; padding-left: 10%">
        <van-field
                v-model="tempName"
                rows="1"
                :autosize="true"
                type="textarea"
                :placeholder="$t('common.inputContent')"
        />
      </div>
    </van-dialog>
    <!--修改詳細地址-->
    <van-dialog
          v-model="isShowDetail"
          :title="$t('publish.address.title')"
          show-cancel-button
          @confirm="confirmDetail"
        >
          <div style="padding: 5px; padding-left: 10%">
            <van-field
              v-model="tempDetail"
              rows="1"
              :autosize="true"
              type="textarea"
              :placeholder="$t('common.inputContent')"
            />
          </div>
        </van-dialog>
    <!--修改聯繫電話-->
    <van-dialog
            v-model="isShowTel"
            :title="$t('form.common.field.mobile.label')"
            show-cancel-button
            @confirm="confirmTel"
          >
            <div style="padding: 5px; padding-left: 10%">
              <van-field
                v-model="tempTel"
                rows="1"
                :autosize="true"
                type="textarea"
                :placeholder="$t('common.inputContent')"
              />
            </div>
          </van-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import { Cell, CellGroup, NavBar, RadioGroup, Radio, Dialog, Field, Toast } from "vant";
import HRegionSelect from "@/components/HRegionSelect";
import { updateUserInfo, updatePassword } from "@/api/user";
import DragUploader from "@/components/DragUploader";
import Region from "@/components/region";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(NavBar);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(Field);
export default {
  components: { HRegionSelect, DragUploader, Region},
  data() {
    return {
      form: {
        phone: null,
        region: null,
        avatar: null,
      },
      defaultValue: "",
      isShowDetail: false,
      tempDetail: null,
      tempAccount: null,
      isShowTel: false,
      tempTel: null,
      isShowName:false,
      tempName:null,
      avatar: '/ssr/static/images/default_avatar.jpg',
    };
  },
  created() {
    this.form = this.userInfo;
  },
  mounted() {
    if(this.userInfo.parent_regoin && this.userInfo.parent_regoin.length > 0) {
      const nameArr = this.userInfo.parent_regoin.map(item => item.name);
      this.defaultValue = nameArr.join("/");
      console.log(this.defaultValue)
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout")
    },
    onClickBack() {
      this.$router.back();
    },
    // selectedData(val) {
    //   this.form.region = val;
    // },
    updateRegin(selectedVal) {
      this.form.region = selectedVal.id;
      this.form.region_name = selectedVal.name;
      console.log("===region===", selectedVal)
    },
    //回調方法，up為上傳實例對像
    getUploader: function (up) {
      let _this = this;
      _this.$nextTick(() => {
        up.bind("UploadComplete", function (up, file) {
          _this.form.avatar = _this.$refs.uploader.fileList[0].url;
        });
      });
    },
    confirmAccount() {
      this.form.phone = this.tempAccount;
      this.tempAccount = null;
    },
    confirmName(){
      this.form.name = this.tempName;
      this.tempName = null
    },
    confirmDetail()  {
      this.form.address = this.tempDetail;
      this.tempDetail = null;
    },
    confirmTel() {
      this.form.tel = this.tempTel;
      this.tempTel = null;
    },
    handleSubmit() {
      updateUserInfo(this.form).then((res) => {
        this.$message.success(this.$i18n.t("message.saveSuccess"));
        this.$store.dispatch("getUserInfo", this.form);
      }).catch((err) =>{

      })
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    // region() {
    //   let area = "";
    //   if (this.form.parent_regoin.length) {
    //     this.form.parent_regoin.forEach((item, index) => {
    //       area = index === 0 ? item.name : area + "/" + item.name;
    //     });
    //   }
    //   return area;
    // },
  },
};
</script>
<style lang="less" scoped>
.content-container {
  background-color: #faf9f9;
  min-height: 100vh;
}
.cell-group-style {
  margin-top: 5px;
}
.avatar {
  display: inline-block;
  width: 24px;
  border-radius: 50px;
  overflow: hidden;
}
.submit {
  margin: 16px
}
/deep/ .ant-input {
    border: none;
    text-align: right;
  }
</style>
